import { Node } from "@tiptap/core";

export interface DocumentVariableOptions {
    HTMLAttributes: Record<string, any>;
}

export const DocumentVariable = Node.create<DocumentVariableOptions>({
    name: "documentVariable",
    inline: true,
    group: "inline",
    atom: false,
    selectable: false,
    draggable: true,

    addAttributes() {
        return {
            name: {
                default: null,
            },
            label: {
                default: null,
            },
            title: {
                default: null,
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: "span[data-variable-name]",
            },
        ];
    },

    // renderHTML({ HTMLAttributes }) {
    //     return [
    //         "span",
    //         mergeAttributes(
    //             {
    //                 "data-variable-name": HTMLAttributes.name,
    //                 "data-variable-label": HTMLAttributes.label,
    //                 contenteditable: "true",
    //                 class: "variable-tag",
    //             },
    //             HTMLAttributes
    //         ),
    //         `${HTMLAttributes.label}`,
    //     ];
    // },
    renderHTML({ HTMLAttributes }) {
        const span = document.createElement("span");
        span.setAttribute("data-variable-name", HTMLAttributes.name);
        span.setAttribute("data-variable-label", HTMLAttributes.label || "");
        span.setAttribute("contenteditable", "true");
        span.classList.add("variable-tag");
        if (HTMLAttributes.title) {
            span.setAttribute("title", HTMLAttributes.title);
        }
        if (HTMLAttributes.label) {
            span.setAttribute("label", HTMLAttributes.label);
        }
        if (HTMLAttributes.name) {
            span.setAttribute("name", HTMLAttributes.name);
        }

        span.innerHTML = HTMLAttributes.label || "";

        return span;
    },
});
